import axios from "axios";
import { useQuery } from "react-query";

const useGetCharities = () => {
  const query = useQuery(
    "charities",
    async () => {
      try {
        return await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/charity`
        );
      } catch (error) {
        console.log(error);
      }
    },
    {
      staleTime: 30000,
    }
  );

  return query;
};

export default useGetCharities;
